// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1J7kh","detailsBorder":"styles_detailsBorder__2Hf4l"};